import { isBrowser } from "@/libs/helpers";

const parseStatus = (
  status: any,
  res: any,
  apolloLogger: any,
  correlationId: string,
  url: string,
  pageUrl?: string
) => {
  return new Promise((resolve, reject) => {
    if (status >= 200 && status < 300) {
      if (res.url.indexOf(".html") > -1) {
        return resolve(res);
      }

      apolloLogger?.info({
        event: `API_REST_${url}`,
        message: `${url} API Success`,
        correlationId: correlationId,
        identifier: pageUrl,
      });
      res.json().then((response: any) => resolve(response));
    } else {
      apolloLogger?.error({
        event: `API_REST_${url}`,
        error: res,
        type: `${res?.name}`,
        message: `${url} API Error- Promise rejected `,
        correlationId: correlationId,
        identifier: pageUrl,
      });
      res.json().then((response: any) => reject(response));
    }
  });
};

const requestHeaders = (
  ctype: string,
  useToken: boolean,
  token?: string,
  isExternalLogin?: boolean,
  correlationId?: string,
  apolloLogger?: any,
  appendXToken?: boolean,
  signedInToken?: string
) => {
  const externalAuthToken = isBrowser() && sessionStorage.getItem("t");
  const source = isBrowser() && sessionStorage.getItem("utm_source");

  let defaultHeader = {
    "Content-Type": ctype || "application/json",
    ...(apolloLogger && { "X-Correlation-ID": correlationId }),
  };

  if (isExternalLogin) {
    if (localStorage.getItem("preAuthToken")) {
      defaultHeader["x-app-os"] = "web";
      defaultHeader["x-apollo-pre-auth-key"] = localStorage.getItem("preAuthToken");
      defaultHeader["x-app-device-id"] = "Desktop";
    }

    if (externalAuthToken) {
      defaultHeader["x-external-auth-token"] = encodeURIComponent(externalAuthToken);
    }

    if (source) {
      defaultHeader["x-utm-source"] = source;
    }
  }

  const getXtoken = () => {
    if (appendXToken && signedInToken) {
      return {
        "X-TOKEN": signedInToken,
      };
    }

    return;
  };

  return useToken
    ? {
        ...defaultHeader,
        Authorization: token || "Basic Y29udGVudDp3YWxtYXJ0TlVUdG9reW9IZWlzdA==",
        ...getXtoken(),
      }
    : {
        ...defaultHeader,
      };
};

export const fetchUtil: (payload: {
  url: string;
  method: "GET" | "POST" | "PUT" | "DELETE";
  body: object;
  useToken: boolean;
  ctype?: string;
  useHeaders?: string;
  token?: string;
  abortController?: AbortController;
  credentials?: "include" | string;
  isExternalLogin?: boolean;
  defaultCache?: boolean;
  apolloLogger?: any;
  correlationId?: string;
  appendXToken?: boolean;
  signedInToken?: string;
  pageUrl?: string;
}) => any = async ({
  url,
  method,
  body = {},
  ctype = "",
  useToken,
  useHeaders = "",
  token = "",
  abortController = undefined,
  credentials = "",
  isExternalLogin = false,
  defaultCache = false,
  apolloLogger = null,
  correlationId = "",
  appendXToken = false,
  signedInToken = "",
  pageUrl = "",
}) => {
  let options = {};

  if (method === "GET") {
    options = useHeaders
      ? { method }
      : {
          method,
          headers: requestHeaders(
            ctype,
            useToken,
            token,
            isExternalLogin,
            correlationId,
            apolloLogger,
            appendXToken,
            signedInToken
          ),
        };
  } else {
    options = {
      method,
      headers: requestHeaders(
        ctype,
        useToken,
        token,
        isExternalLogin,
        correlationId,
        apolloLogger,
        appendXToken,
        signedInToken
      ),
      body: JSON.stringify(body),
    };
  }

  if (credentials) options = { ...options, credentials };
  if (defaultCache) options = { cache: "force-cache", ...options };
  const { signal = null } = abortController || {};

  try {
    const res = await fetch(url, signal ? { ...options, signal } : options);

    return await parseStatus(res.status, res, apolloLogger, correlationId, url, pageUrl);
  } catch (err: any) {
    apolloLogger?.error({
      event: `API_REST_${url}`,
      error: err,
      type: `${err?.name}`,
      message: `${url} API Error`,
      correlationId: correlationId,
      identifier: pageUrl,
    });
    console.error(err);
  }
};
